import { ParamTypeDateTime } from '../components/Purchase/LotParams/LotParam.type';
import formatMomentDate from './formatMomentDate';

export const formatLotParamDateTime = (
    type: ParamTypeDateTime,
    value: any
): string => {
    const { format, range } = type;

    if (range) {
        return [
            formatMomentDate(value?.[0], format),
            formatMomentDate(value?.[1], format),
        ].join(' — ');
    }

    return formatMomentDate(value, format);
};
